import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';

export const SeoBreadcrumbs = ({ data }) => {
  return (
    <Breadcrumb>
      {data.map(({ text, href, isCurrentPage }) => (
        <BreadcrumbItem key={text}>
          <BreadcrumbLink href={href} fontSize={['sm', 'sm', 'lg', 'lg']} isCurrentPage={isCurrentPage}>
            {text}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};
